import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'
import { TShipmentIssueSchema, ShippmentIssueSchemaObject } from '../../CreateNewIssueModal/schema'
import { DispatchShipmentModalSchemaObject } from '../../DispatchShipmentModal/DispatchShipmentModalSchema'

const REQUIRED_MESSAGE = 'This field is required'

export type TLoadType =
  | 'next-eta'
  | 'carrier-unresponsive'
  | 'bounce-recomendation'
  | 'osd'
  | 'claims'

export const LoadUpdateSchema = yup.object({
  type: yup.mixed<TLoadType>().required(REQUIRED_MESSAGE).default('next-eta'),
  ...ShippmentIssueSchemaObject,
  ...DispatchShipmentModalSchemaObject,
})

export type TLoadUpdateSchema = yup.InferType<typeof LoadUpdateSchema>

export const useCreateIssueModalFormContext = () => useFormContext<TShipmentIssueSchema>()

export const useLoadUpdateModalFormContext = () => useFormContext<TLoadUpdateSchema>()
